module.exports = __webpack_public_path__ + "images/webhooks/test_now_button_before_saving.png";